var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup427320194(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 50,
    viewBox: "0 0 66 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3066 6.33516V25.5402C50.3066 29.0387 47.4699 31.8754 43.9714 31.8754H25.6617L16.4725 38.8085C15.447 39.5823 13.979 38.8511 13.979 37.5661V31.8746H6.33516C2.83666 31.8754 0 29.0395 0 25.5402V6.33516C0 2.83666 2.83666 0 6.33516 0H43.9714C47.4699 0 50.3066 2.83666 50.3066 6.33516Z",
    fill: "#ED4C28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8643 24.4912V39.4318C65.8643 42.1533 63.6579 44.3596 60.9364 44.3596H54.9901V48.7874C54.9901 49.7861 53.8479 50.3556 53.0504 49.7537L45.9019 44.3596H31.6579C28.9364 44.3596 26.73 42.1533 26.73 39.4318V33.211H43.9716C48.2014 33.211 51.6423 29.7701 51.6423 25.5403V19.5625H60.9364C63.6579 19.5625 65.8643 21.7689 65.8643 24.4904V24.4912Z",
    fill: "#F26639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1529 19.134C26.9182 19.134 28.3493 17.7029 28.3493 15.9376C28.3493 14.1723 26.9182 12.7412 25.1529 12.7412C23.3876 12.7412 21.9565 14.1723 21.9565 15.9376C21.9565 17.7029 23.3876 19.134 25.1529 19.134Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9879 19.134C15.7532 19.134 17.1842 17.7029 17.1842 15.9376C17.1842 14.1723 15.7532 12.7412 13.9879 12.7412C12.2226 12.7412 10.7915 14.1723 10.7915 15.9376C10.7915 17.7029 12.2226 19.134 13.9879 19.134Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3189 19.134C38.0842 19.134 39.5153 17.7029 39.5153 15.9376C39.5153 14.1723 38.0842 12.7412 36.3189 12.7412C34.5536 12.7412 33.1226 14.1723 33.1226 15.9376C33.1226 17.7029 34.5536 19.134 36.3189 19.134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup427320194);
export default __webpack_public_path__ + "static/media/Group 427320194.3bdbbd5f8bb0e3dc1935167359c9e1a9.svg";
export { ForwardRef as ReactComponent };